import { api } from '@/api/api';
import { apis } from '@/config';
class FeedbackApiImpl {
    constructor() {
        this.name = apis.feedbackApiImpl;
        this.httpApi = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    getUrl(url) {
        return this.systemApi.getUrl(url);
    }
    parseResult(res) {
        return res.data;
    }
    catchError(reason) {
        return reason;
    }
    getNosTokenNoLogin(option) {
        return this.httpApi.get(this.getUrl('getNosTokenNoLogin'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    getNosToken(option) {
        return this.httpApi.get(this.getUrl('getNosToken'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    submitFeedback(option) {
        return this.httpApi.post(this.getUrl('submitFeedback'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
    submitFeedbackNoLogin(option) {
        return this.httpApi.post(this.getUrl('submitFeedbackNoLogin'), option, { contentType: 'json' }).then(this.parseResult).catch(this.catchError);
    }
}
const feedbackApiImpl = new FeedbackApiImpl();
api.registerLogicalApi(feedbackApiImpl);
export default feedbackApiImpl;
